import React, { useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Gallery from './components/Gallery';
import WhyChooseUs from './components/WhyChooseUs';
import SEOContent from './components/SEOContent';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import { initializeTracking, reportToSearchConsole } from './utils/analytics';

function App() {
  useEffect(() => {
    // Initialize tracking when app loads
    initializeTracking();
    
    // Report successful page load to Search Console
    reportToSearchConsole.pageLoad(window.location.href);
    
    // Set page title for SEO
    document.title = "Premier Dental Clinic - Best Dental Treatment in Bhaktapur | +977 981-3538101";
  }, []);

  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <Services />
      <Gallery />
      <WhyChooseUs />
      <SEOContent />
      <Contact />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
